'use client';

import { Collapsible } from '@base-ui/react/collapsible';
import cn from 'classnames';
import type { ReactNode } from 'react';

import classes from './SwdCollapse.module.scss';

export type SwdCollapseProps = {
  /** MUI Collapse `in` prop */
  in: boolean;
  children: ReactNode;
  className?: string;
  orientation?: 'horizontal' | 'vertical';
  /** Keep panel content in the DOM while collapsed (needed for CSS-only desktop expand). */
  keepMounted?: boolean;
};

/**
 * Visibility toggle (replaces MUI Collapse for simple show/hide).
 */
export function SwdCollapse({
  in: open,
  children,
  className,
  orientation: _orientation = 'vertical',
  keepMounted = false,
}: SwdCollapseProps) {
  return (
    <Collapsible.Root className={cn(className)} open={open}>
      <Collapsible.Panel keepMounted={keepMounted} className={classes.collapsiblePanel}>
        {children}
      </Collapsible.Panel>
    </Collapsible.Root>
  );
}
